"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidPrivateKeyFormat = exports.InvalidChecksumAddress = exports.ProtocolNotSupported = exports.InvalidSubAddress = exports.InvalidNetwork = exports.InvalidNamespace = exports.InvalidPayloadLength = exports.UnknownProtocolIndicator = exports.InvalidProtocolIndicator = void 0;
class InvalidProtocolIndicator extends Error {
    constructor(value) {
        super();
        this.message = `Invalid protocol indicator byte [${value}]`;
    }
}
exports.InvalidProtocolIndicator = InvalidProtocolIndicator;
class UnknownProtocolIndicator extends Error {
    constructor(value) {
        super();
        this.message = 'Unknown protocol indicator byte [${value}]';
    }
}
exports.UnknownProtocolIndicator = UnknownProtocolIndicator;
class InvalidPayloadLength extends Error {
    constructor(len) {
        super();
        this.message = `Invalid payload length [${len}]`;
    }
}
exports.InvalidPayloadLength = InvalidPayloadLength;
class InvalidNamespace extends Error {
    constructor(value) {
        super();
        this.message = `Invalid namespace [${value}]`;
    }
}
exports.InvalidNamespace = InvalidNamespace;
class InvalidNetwork extends Error {
    constructor(value) {
        super();
        this.message = `Invalid network [${value}]`;
    }
}
exports.InvalidNetwork = InvalidNetwork;
class InvalidSubAddress extends Error {
    constructor() {
        super();
        this.message = 'Invalid subAddress.';
    }
}
exports.InvalidSubAddress = InvalidSubAddress;
class ProtocolNotSupported extends Error {
    constructor(protocolName) {
        super();
        this.message = `${protocolName} protocol not supported.`;
    }
}
exports.ProtocolNotSupported = ProtocolNotSupported;
class InvalidChecksumAddress extends Error {
    constructor(checksum1, checksum2) {
        super();
        this.message = `Invalid address (checksum not matching the payload). ${checksum1} vs ${checksum2}`;
    }
}
exports.InvalidChecksumAddress = InvalidChecksumAddress;
class InvalidPrivateKeyFormat extends Error {
    constructor() {
        super();
        this.message = 'Private key need to be an instance of Buffer or a base64 string.';
    }
}
exports.InvalidPrivateKeyFormat = InvalidPrivateKeyFormat;
